/* eslint-disable max-len */
import { memo } from 'react';
import { Icon } from 'react-bootstrap-icons';

export const OpenInNewTabIcon: Icon = memo(({
  color = 'currentColor',
  size = '1em',
  title = null,
  ...rest
}) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={ size }
      height={ size }
      fill={ color }
      { ...rest }
    >
      { title ? <title>{ title }</title> : null }

      <path d="M 2.512 4.009 C 2.896 4.009 3.137 3.592 2.945 3.259 C 2.855 3.104 2.69 3.009 2.512 3.009 C 2.127 3.009 1.886 3.425 2.079 3.759 C 2.168 3.913 2.333 4.009 2.512 4.009 M 4.012 4.009 C 4.396 4.009 4.637 3.592 4.445 3.259 C 4.355 3.104 4.19 3.009 4.012 3.009 C 3.627 3.009 3.386 3.425 3.579 3.759 C 3.668 3.913 3.833 4.009 4.012 4.009 M 6.012 3.509 C 6.012 3.893 5.595 4.134 5.262 3.942 C 5.107 3.852 5.012 3.687 5.012 3.509 C 5.012 3.124 5.428 2.883 5.762 3.076 C 5.916 3.165 6.012 3.33 6.012 3.509" fill={ color }/>
      <path d="M 0.012 3.009 C 0.012 1.904 0.907 1.009 2.012 1.009 L 13.012 1.009 C 14.116 1.009 15.012 1.904 15.012 3.009 L 15.012 7.009 C 15.012 7.393 14.595 7.634 14.262 7.442 C 14.107 7.352 14.012 7.187 14.012 7.009 L 14.012 6.009 L 1.012 6.009 L 1.012 11.009 C 1.012 11.561 1.459 12.009 2.012 12.009 L 7.512 12.009 C 7.896 12.009 8.137 12.425 7.945 12.759 C 7.855 12.913 7.69 13.009 7.512 13.009 L 2.012 13.009 C 0.907 13.009 0.012 12.113 0.012 11.009 L 0.012 3.009 Z M 1.012 5.009 L 14.012 5.009 L 14.012 3.009 C 14.012 2.456 13.564 2.009 13.012 2.009 L 2.012 2.009 C 1.459 2.009 1.012 2.456 1.012 3.009 L 1.012 5.009 Z" fill={ color }/>
      <path d="M 9.009 11.504 C 9.009 14.212 11.928 15.906 14.264 14.55 C 15.348 13.922 16.016 12.76 16.016 11.504 C 16.016 8.793 13.095 7.1 10.76 8.454 C 9.675 9.084 9.009 10.245 9.009 11.504 M 11.594 12.735 C 11.477 12.858 11.273 12.806 11.226 12.644 C 11.204 12.566 11.227 12.481 11.285 12.425 L 13.078 10.624 L 11.866 10.624 C 11.697 10.624 11.592 10.439 11.677 10.294 C 11.716 10.225 11.787 10.184 11.866 10.184 L 13.608 10.184 C 13.727 10.184 13.826 10.28 13.826 10.404 L 13.826 12.152 C 13.826 12.321 13.643 12.427 13.498 12.342 C 13.43 12.303 13.388 12.229 13.388 12.152 L 13.388 10.934 L 11.594 12.735 Z" fill={ color }/>
    </svg>
  );
});
